import { render } from "./RDataList.vue?vue&type=template&id=7aeb7e04"
import script from "./RDataList.vue?vue&type=script&lang=js"
export * from "./RDataList.vue?vue&type=script&lang=js"

import "./RDataList.vue?vue&type=style&index=0&id=7aeb7e04&lang=css"
script.render = render

export default script